import type { Release } from '../releases';

export default {
  id: '2026-11-01-supervision-inbox',
  at: '2026-11-01T06:22:00Z',
  title: 'Замечания, предписания и освидетельствования — в «Ждёт меня» и в карточке проекта',
  modules: ['supervision', 'psd'],
  items: [
    'В «Ждёт меня» появились дела надзора: выдавшему — проверить устранённое или оспоренное замечание, и просроченное замечание; подрядчику — устранить замечание к сроку; технадзору заказчика — принять или отклонить вызов на освидетельствование; вызвавшему — вызов, по которому прошёл назначенный день, а решения нет.',
    'Эти же строки видны в блоке «Требует внимания» на вкладке «Обзор» проекта. Когда дело сделано, строка исчезает сама.',
    'Если сотруднику уже поставлено поручение по замечанию или вызову, вторая строка не появляется.',
    'В карточке листа ПСД и замечания — ссылка на фото площадки из отчётов смены, привязанные к этому листу или замечанию.',
  ],
  why: 'Дела надзора не попадали ни в «Ждёт меня», ни в карточку проекта: устранённые замечания ждали проверки незаметно, а внешний технадзор и подрядчик не видели своих сроков.',
  link: '/inbox',
} satisfies Release;
